<script>
  import { onMount } from "svelte";
  import Select, { Option } from "@smui/select";
  import SelectHelperText from "@smui/select/helper-text";
  import FormField from "@smui/form-field";
  import Switch from "@smui/switch";
  import Radio from "@smui/radio";
  import Checkbox from "@smui/checkbox";
  import { Textfield } from "../components";

  export let data;
  export let errors = {};
  let defaultData = {
    service_style: "buffet_served",
    cooking_allowed: false,
    menu_type: "hot",
    meat_main_reqd: false,
    fish_main_reqd: false,
    veg_main_reqd: false,
    bread_reqd: false,
    side_reqd: false,
    dessert_reqd: false,
    dr_num_other_allergies: 0,
    dr_num_dairy_allergies: 0,
    dr_num_nut_allergies: 0,
    dr_num_gluten_free: 0,
    dr_num_vegan: 0,
    dr_num_vegetarian: 0,
    consumables_required: "not_required",
    clean_up: "own"
  };

  const serviceStyles = [
    { val: "boxed_drop", label: "Boxed meal - Drop and leave" },
    { val: "boxed", label: "Boxed meal - Caterer support" },
    { val: "buffet_self", label: "Buffet - Self service" },
    { val: "buffet_served", label: "Buffet - Catered service" },
    { val: "seated", label: "Sit down meal - Catered service" },
    { val: "canape", label: "Canape - Catered service" }
  ];

  const menuTypes = [
    { val: "hot", label: "Hot where possible" },
    { val: "cold", label: "Cold" }
  ];

  const consumables = [
    {
      val: "not_required",
      label: "Customer will provide plates, cutlery and consumables"
    },
    { val: "boxes", label: "Caterer to provide boxes" },
    { val: "all", label: "Caterer to provide boxes, cutlery and consumables" }
  ];

  const clean_up = [
    { val: "own", label: "own clean up only" },
    { val: "all", label: "customer and own clean up" }
  ];

  onMount(() => {
    if (!data) {
      data = defaultData;
    }
    console.log("data: ", data);
  });
</script>

<style>
  .column {
    padding-right: 50px;
  }
</style>

{(console.log('Catering requirements errors: ', errors), '')}
{#if data}
  <Select label="Service Style" bind:value={data.service_style}>
    {#each serviceStyles as ss}
      <Option value={ss.val}>{ss.label}</Option>
    {/each}
  </Select>
  <p>
    <FormField>
      <Switch bind:checked={data.cooking_allowed} />
      <span slot="label">Cooking allowed on-site</span>
    </FormField>
  </p>
  <p>
    {#each menuTypes as mt}
      <FormField>
        <Radio bind:group={data.menu_type} value={mt.val} />
        <span slot="label">{mt.label}</span>
      </FormField>
    {/each}
  </p>
  <h4>Menu expecation at this price</h4>
  <div class="flex no-spread">
    <div class="column">
      <p>
        <FormField>
          <Checkbox bind:checked={data.meat_main_reqd} />
          <span slot="label">Meat main</span>
        </FormField>
      </p>
      <p>
        <FormField>
          <Checkbox bind:checked={data.fish_main_reqd} />
          <span slot="label">Fish main</span>
        </FormField>
      </p>
      <p>
        <FormField>
          <Checkbox bind:checked={data.veg_main_reqd} />
          <span slot="label">Vegetarian main</span>
        </FormField>
      </p>
    </div>
    <div class="column">
      <p>
        <FormField>
          <Checkbox bind:checked={data.bread_reqd} />
          <span slot="label">Bread</span>
        </FormField>
      </p>
      <p>
        <FormField>
          <Checkbox bind:checked={data.side_reqd} />
          <span slot="label">Side</span>
        </FormField>
      </p>
      <p>
        <FormField>
          <Checkbox bind:checked={data.dessert_reqd} />
          <span slot="label">Dessert</span>
        </FormField>
      </p>
    </div>
  </div>
  <div class="flex no-spread">
    <div class="column">
      <h4>Dietry requests</h4>
      <Textfield
        type="number"
        class="number"
        bind:value={data.dr_num_vegetarian}
        label="Vegetarian"
        error={errors.dr_num_vegetarian} />
      <Textfield
        type="number"
        class="number"
        bind:value={data.dr_num_vegan}
        label="Vegan"
        error={errors.dr_num_vegan} />
      <Textfield
        type="number"
        class="number"
        bind:value={data.dr_num_gluten_free}
        label="Gluten Free"
        error={errors.dr_num_gluten_free} />
    </div>
    <div>
      <h4>Allergies</h4>
      <Textfield
        type="number"
        class="short"
        bind:value={data.dr_num_nut_allergies}
        label="Nut Allergies"
        helperText="Please detail below"
        error={errors.dr_num_nut_allergies} />
      <Textfield
        type="number"
        class="short"
        bind:value={data.dr_num_dairy_allergies}
        label="Dairy Allergies"
        error={errors.dr_num_dairy_allergies} />
      <Textfield
        type="number"
        class="short"
        bind:value={data.dr_num_other_allergies}
        label="Other Allergies"
        helperText="Please detail below"
        error={errors.dr_num_other_allergies} />
    </div>
  </div>
  <p>
    <Textfield
      fullwidth
      textarea
      bind:value={data.dr_allergy_notes}
      label="Allergy notes"
      error={errors.dr_allergy_note} />
  </p>
  <h4>Dishes and consumables</h4>
  <Select
    label="Consumables"
    bind:value={data.consumables_required}
    invalid={!!errors.consumables_required}>
    {#each consumables as i}
      <Option value={i.val}>{i.label}</Option>
    {/each}
  </Select>
  <SelectHelperText validationMsg>
    {errors.consumables_required}
  </SelectHelperText>
  <p />
  <h4>Caterer clean up requirements</h4>
  {#each clean_up as i}
    <FormField>
      <Radio bind:group={data.clean_up} value={i.val} />
      <span slot="label">{i.label}</span>
    </FormField>
  {/each}
{/if}
